import React, { useState } from 'react'

import { Fieldset, Upload } from '@fourthwall/components'
import { fileToBase64 } from '@fourthwall/utils/dist/file'
import { useFormikContext } from '@fourthwall/utils/dist/formik'

import { RemovableUpload, UploadedImage } from '../../../../../components'
import type { FormValues } from '../../types'
import { FormFields } from '../../types'
import * as S from './styled'

type Props = {
  imageSrc?: string
}

export const ImageFields = ({ imageSrc }: Props) => {
  const [initialImage, setInitialImage] = useState(imageSrc)

  const { values, setFieldValue } = useFormikContext<FormValues>()

  const handleFileDrop = async (files?: File[]) => {
    if (files?.[0]) {
      const base64 = await fileToBase64(files[0])

      setFieldValue(FormFields.image, base64)
      setFieldValue(FormFields.removeImage, false)
    }
  }

  const renderUpload = () => {
    const image = values.image || initialImage

    if (image) {
      return (
        <RemovableUpload
          onRemove={() => {
            setFieldValue(FormFields.image, '')
            setInitialImage(undefined)
            setFieldValue(FormFields.removeImage, true)
          }}
        >
          <UploadedImage image={image} />
        </RemovableUpload>
      )
    }

    return (
      <Upload
        accept={{
          'image/*': [],
        }}
        iconSize={20}
        orientation="horizontal"
        title=""
        onFileDrop={handleFileDrop}
      />
    )
  }

  return (
    <Fieldset.Row>
      <Fieldset.Item>
        <S.ImageInputContainer>
          <S.UploadContainer>{renderUpload()}</S.UploadContainer>
          RSS image (optional)
        </S.ImageInputContainer>
      </Fieldset.Item>
    </Fieldset.Row>
  )
}
